import React from 'react';
import { Box } from '@mui/material';
import NosotrosHero from './components/NosotrosHero';
import NosotrosPillars from './components/NosotrosPillars';
import NosotrosValues from './components/NosotrosValues';

export default function Nosotros() {
  return (
    <Box component="main" sx={{backgroundColor: '#white'}}>
      <NosotrosHero />
      <NosotrosPillars />
      <NosotrosValues />
    </Box>
  );
}